import React from 'react';

class ShareContent extends React.Component {

  onCopyClick() {
    const copyinput = this.node;
    copyinput.select();

    try {
      document.execCommand('copy');
      this.setState({ copied: true });
    } catch (err) {
      console.warn('Oops, unable to copy');
    }
  }

  render() {
    return (
      <div className="share">
        <h1 className="title">Share</h1>
        <div className="media">
          <a href={`http://www.facebook.com/sharer/sharer.php?u=${window.location.href}`} target="_blank" title="Facebook">
            <svg className="c-icon -dark icon-facebook"><use xlinkHref="#icon-facebook"></use></svg>
          </a>
          <a href={`https://twitter.com/share?url=${window.location.href}&text=2017 Resource Governance Index`} target="_blank" title="Twitter">
            <svg className="c-icon -dark icon-twitter"><use xlinkHref="#icon-twitter"></use></svg>
          </a>
        </div>

        <h5>Copy the link below to share it</h5>
        <div className="actions">
          <input ref={(node) => { this.node = node; }} value={window.location.href} className="url" readOnly />
          <button className="c-btn -filled -primary" onClick={() => this.onCopyClick()} >
            Copy
          </button>
        </div>
      </div>
    );
  }
}

export default ShareContent;



// WEBPACK FOOTER //
// ./app/components/common/modals/ShareContent.jsx